module.exports = new __parcel__URL__("hand_pointing_7_oclock.fd4a1315.png").toString();